"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UICardSection;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _CardContext = require("../context/CardContext");

var _decorators = require("../utils/propTypes/decorators");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: ", ";\n  border-radius: inherit;\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  + .private-card__section,\n  + * .private-card__section {\n    padding-top: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex: 1 1 auto;\n  overflow: auto;\n\n  &:last-child {\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var scrollableMixin = (0, _styledComponents.css)(_templateObject(), function (_ref) {
  var compact = _ref.compact;
  return compact ? '24px' : '40px';
});
var siblingPaddingMixin = (0, _styledComponents.css)(_templateObject2());

var Section = _styledComponents.default.div.withConfig({
  displayName: "UICardSection__Section",
  componentId: "ibpgvt-0"
})(_templateObject3(), function (_ref2) {
  var compact = _ref2.compact,
      flush = _ref2.flush,
      isHeader = _ref2.isHeader,
      scrollable = _ref2.scrollable;
  var paddingTop = compact ? '24px' : '40px';
  var paddingBottom = isHeader || scrollable ? '0' : paddingTop;
  var paddingX = flush ? '0' : paddingTop;
  return paddingTop + " " + paddingX + " " + paddingBottom;
}, function (_ref3) {
  var scrollable = _ref3.scrollable;
  return scrollable ? scrollableMixin : siblingPaddingMixin;
});

function UICardSection(_ref4) {
  var className = _ref4.className,
      rest = (0, _objectWithoutProperties2.default)(_ref4, ["className"]);

  var _useContext = (0, _react.useContext)(_CardContext.CardContext),
      compact = _useContext.compact;

  return _react.default.createElement(Section, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-card__section', 'has--vertical-spacing', className),
    compact: compact
  }));
}

UICardSection.defaultProps = {
  flush: false,
  isHeader: false,
  scrollable: false
};
UICardSection.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool,
  isHeader: (0, _decorators.hidden)(_propTypes.default.bool),
  scrollable: _propTypes.default.bool
};
UICardSection.displayName = 'UICardSection';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/card/UICardSection.js
// module id = 137
// module chunks = 209 210 211 212